import type { FaireProductEntity } from "../../entity_types/product";

export const p_4yuh4mwxld: FaireProductEntity = {
  token: "p_4yuh4mwxld",
  type: "product",
  name: "Amethyst Polished Points - Calming Amethyst",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/7b404d6c6d84d4d809e04bcb289766f80fba6b98d17c1cc7382311b5d5e7d2d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c23a73045bd0b7a3a711aace38b7e22ca123e6fee523bc21a326dcf4c7a94fe.jpeg",
    "https://cdn.faire.com/fastly/5394d33f6521899f347736d27ca2ecec9cf8f723439f59780c3448e05820fe6b.jpeg",
  ],
  priceDollars: 38.8,
  description:
    "The Amethyst acts as a powerful and protective crystal. Being a natural stress reliever it brings calmness and dispels negativity from its surroundings. The mini Amethyst points release pure vibrations and healing energy through their apex that deeply nourish the soul, balance emotions and  and enhance psychic abilities. Ideal for use in meditation and healing spaces or in a Crystal Grid as Amethyst promotes spiritual growth. They make an exquisite item for decor as well as a gift for any occasion. Buy our high quality, polished mini Amethyst points, sourced from Brazil, with confidence that they will elevate your product offering to the next level.\n\nSize (approx.): 1 inch\nSold: Per lb",
  tags: [],
  msrpDollars: 77.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:58.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
